import React from 'react';

// Small pill label. Tones map to brand + status washes (BRAND.md §2).
const TONES = {
  new:     { bg: 'var(--sedra-tan-wash)', fg: 'var(--status-warn-dark)' },
  sage:    { bg: 'var(--sedra-sage-wash)', fg: 'var(--sedra-sage-ink)' },
  forest:  { bg: 'var(--sedra-forest)', fg: 'var(--sedra-cream)' },
  tan:     { bg: 'var(--sedra-tan)', fg: 'var(--sedra-forest)' },
  neutral: { bg: 'var(--sedra-line)', fg: 'var(--sedra-ink)' },
  success: { bg: 'var(--status-success-bg)', fg: 'var(--status-success)' },
  warn:    { bg: 'var(--status-warn-bg)', fg: 'var(--status-warn-dark)' },
  danger:  { bg: 'var(--status-danger-bg)', fg: 'var(--status-danger)' },
  info:    { bg: 'var(--status-info-bg)', fg: 'var(--status-info)' },
};

/** Badge — compact label pill (e.g. "New", role tags). BRAND.md caption scale. */
export function Badge({ tone = 'sage', children, style }) {
  const t = TONES[tone] || TONES.sage;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center',
      padding: '3px 10px', borderRadius: 'var(--radius-pill)',
      fontFamily: 'var(--font-body)', fontSize: 12, fontWeight: 600,
      lineHeight: 1.4, letterSpacing: 0,
      background: t.bg, color: t.fg, ...style,
    }}>{children}</span>
  );
}
